import Phaser from 'phaser';
import { DESIGN, COLORS } from '@/config';
import { sfx } from '@/audio/Sfx';

/** Title screen: key-art + Play. Play opens the World Map (level select), where
 *  the stage and its difficulty are chosen per node. */
export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super('menu');
  }

  create(): void {
    const { width, height } = DESIGN;

    this.cameras.main.setBackgroundColor('#1b1e30');

    // Cinematic key-art band behind the title — the Sundered Steps at twilight.
    // Its lower edge fades to the menu bg so there's no visible seam.
    if (this.textures.exists('ui_menu_banner')) {
      this.add.image(width / 2, 230, 'ui_menu_banner').setDisplaySize(width, 460).setDepth(0);
    }

    if (this.textures.exists('ui_emblem')) {
      this.add.image(width / 2, height * 0.17, 'ui_emblem').setDisplaySize(180, 180);
    }

    this.add
      .text(width / 2, height * 0.32, 'ROGUE DEFENDER\nCHAMPIONS', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '56px',
        fontStyle: 'bold',
        color: COLORS.accent,
        align: 'center',
        lineSpacing: 8,
      })
      .setOrigin(0.5);

    this.add
      .text(width / 2, height * 0.46, 'THE SUNDERED STEPS', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '24px',
        fontStyle: 'bold',
        color: '#aab0d8',
        letterSpacing: 2,
      })
      .setOrigin(0.5);
    this.add
      .text(width / 2, height * 0.5, 'Olympus · hold the temple stairs against the Unmade', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '17px',
        color: '#7e84ad',
      })
      .setOrigin(0.5);

    this.makeButton(width / 2, height * 0.66, 'PLAY  ▶', () => {
      sfx.play('click'); // first gesture — also unlocks the audio context
      this.scene.start('worldmap');
    });

    this.add
      .text(
        width / 2,
        height - 40,
        'Drag to pan · pinch or scroll to zoom · tap a slot to deploy',
        {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '16px',
          color: '#7e84ad',
        },
      )
      .setOrigin(0.5);
  }

  private makeButton(x: number, y: number, label: string, onClick: () => void): void {
    const w = 260;
    const h = 64;
    const g = this.add.graphics();
    const draw = (hover: boolean) => {
      g.clear();
      g.fillStyle(hover ? 0x5ac0a0 : 0x3b4066, 1);
      g.lineStyle(2, 0x565d8c, 1);
      g.fillRoundedRect(x - w / 2, y - h / 2, w, h, 12);
      g.strokeRoundedRect(x - w / 2, y - h / 2, w, h, 12);
    };
    draw(false);

    const text = this.add
      .text(x, y, label, {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '26px',
        fontStyle: 'bold',
        color: COLORS.text,
      })
      .setOrigin(0.5);

    const zone = this.add
      .zone(x, y, w, h)
      .setInteractive({ useHandCursor: true });
    zone.on('pointerover', () => draw(true));
    zone.on('pointerout', () => draw(false));
    zone.on('pointerup', onClick);
    text.setDepth(1);
  }
}
